import React from "react";
import "./MediaWaveWordmark.css";

export type MediaWaveWordmarkSurface = "light" | "dark";

type Props = {
  className?: string;
  /** `dark` = inverted for dark bars (header / site footer). `light` = asset as-is (dock, article panel). */
  surface?: MediaWaveWordmarkSurface;
};

const MediaWaveWordmark: React.FC<Props> = ({ className, surface = "light" }) => (
  <span
    className={[
      "media-wave-wordmark",
      surface === "dark" ? "media-wave-wordmark--on-dark" : "media-wave-wordmark--on-light",
      className ?? "",
    ]
      .filter(Boolean)
      .join(" ")}
  >
    <img
      src="/images/the_wave.svg"
      alt="The Wave by Wave of Innovation"
      className="media-wave-wordmark__img"
      width={285}
      height={158}
      decoding="async"
    />
  </span>
);

export default MediaWaveWordmark;
